export const ENTRY_MODE_MAP = 'map'
export const ENTRY_MODE_MANUAL = 'manual'

export const EMPTY_MAP_SELECTION = {
  toids: [],
  uprns: [],
  features: [],
  links: []
}

const MANUAL_FIELDS = ['uprn', 'name', 'street', 'city']

// A saved map selection reopens on the map; saved address fields without one were filled by hand.
// Nothing saved yet means we still have to ask whether the building is a new build.
export const initialEntryMode = bp => {
  if (Array.isArray(bp?.selectedMapToids) && bp.selectedMapToids.length > 0) {
    return ENTRY_MODE_MAP
  }

  return MANUAL_FIELDS.some(field => String(bp?.[field] || '').trim())
    ? ENTRY_MODE_MANUAL
    : null
}

// Keeps what the user or the map already filled in and falls back to the searched postcode.
export const manualEntryValues = (values, searchedPostcode = '') => ({
  ...values,
  postalCode: String(values?.postalCode || searchedPostcode || '')
    .trim()
    .toUpperCase()
})

// Units are synced later from the Building Passport, so nothing from the map outline is kept.
export const manualEntryBpPatch = values => ({
  uprn: values.uprn,
  name: values.name,
  street: values.street,
  city: values.city,
  postalCode: values.postalCode,
  selectedMapToids: [],
  selectedMapUprns: [],
  selectedMapFeatures: [],
  selectedOsLinkedIdentifiers: [],
  suggestedUnitsCount: null
})
